import React from 'react';
import Skeleton from '../../atoms/Skeleton';
import './brandCard.css';

/* The shape of `.bb-card` while it loads — built from the card's own classes so
   the tile cannot change shape without its skeleton following. */
export default function BrandCardSkeleton() {
  return (
    <div className="bb-card" aria-hidden="true">
      <span className="bb-logo"><Skeleton w={104} h={104} shape="circle" /></span>
      <span className="bb-name"><Skeleton w="70%" h={13} /></span>
    </div>
  );
}
